import React, { useEffect, useState } from "react";
import { Award, CalendarPlus } from "lucide-react";
import { AppButton, WhatsAppIcon } from "../../ui";

/**
 * LobbyExtras — the "you're registered" extras in the lobby, where somebody who
 * registered on the LMS's own page lands (the website has its own success
 * card): the WhatsApp group, a calendar entry, and the certificate rule, so
 * they know to stay.
 *
 * Reads `/me` once: the group link is handed only to registrants, never put on
 * the public payload the lobby polls.
 */
const LobbyExtras = ({ api, slug, token, calendarUrl }) => {
  const [me, setMe] = useState(null);

  useEffect(() => {
    if (!token) return undefined;
    let cancelled = false;
    api.getMe(slug, token).then(({ data }) => { if (!cancelled) setMe(data); }).catch(() => {});
    return () => { cancelled = true; };
  }, [slug, token]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!me) return null;
  const cert = me.certificate || {};
  return (
    <div className="tw-mt-4 tw-flex tw-flex-col tw-items-center tw-gap-3">
      <div className="tw-flex tw-flex-wrap tw-justify-center tw-gap-2">
        {calendarUrl && (
          <AppButton size="sm" variant="outline" as="a" href={calendarUrl}>
            <CalendarPlus size={16} /> Add to calendar
          </AppButton>
        )}
        {me.whatsappGroupUrl && (
          <AppButton size="sm" variant="outline" as="a" href={me.whatsappGroupUrl} target="_blank" rel="noopener noreferrer">
            <WhatsAppIcon size={16} /> Join the WhatsApp group
          </AppButton>
        )}
      </div>
      {cert.enabled && (
        <p className="tw-m-0 tw-text-center tw-text-xs tw-text-content-subtle">
          <Award size={12} className="tw-mr-1 tw-inline" aria-hidden="true" />
          Stay for at least {cert.minAttendancePct}% of the session to receive a certificate of participation.
        </p>
      )}
    </div>
  );
};

export default LobbyExtras;
